module.exports = __webpack_public_path__ + "assets/xuanze2.61c997512240910d4f6e14ddad3067ae.png";